import { useEffect } from 'react';

import { PAGE_TITLES_BY_ROUTE } from '@cloud-ui/constants';

import { useLocation } from 'react-router-dom';

const findMatchingRoute = (pathname: string): string | undefined => {
  // First try exact match
  if (PAGE_TITLES_BY_ROUTE[pathname as keyof typeof PAGE_TITLES_BY_ROUTE]) {
    return pathname;
  }

  // Then try to match routes with parameters
  const routes = Object.keys(PAGE_TITLES_BY_ROUTE);
  for (const route of routes) {
    // Convert route pattern like '/eval/:id' to regex
    const routeRegex = new RegExp('^' + route.replace(/:[^/]+/g, '[^/]+') + '$');
    if (routeRegex.test(pathname)) {
      return route;
    }
  }

  return undefined;
};

/**
 * Sets the current page's document title if one is defined.
 *
 */
export default function DocumentTitle() {
  const location = useLocation();

  useEffect(() => {
    const matchingRoute = findMatchingRoute(location.pathname);
    const title = matchingRoute
      ? PAGE_TITLES_BY_ROUTE[matchingRoute as keyof typeof PAGE_TITLES_BY_ROUTE]
      : undefined;
    if (title) {
      document.title = `${title} | promptfoo`;
    } else {
      // Default title:
      document.title = 'promptfoo';
    }
  }, [location.pathname]);

  return null;
}
